import { render } from "./ListFilterUnits.vue?vue&type=template&id=2f273368&scoped=true&ts=true"
import script from "./ListFilterUnits.vue?vue&type=script&lang=ts"
export * from "./ListFilterUnits.vue?vue&type=script&lang=ts"

import "./ListFilterUnits.vue?vue&type=style&index=0&id=2f273368&scoped=true&lang=scss"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f273368"]])

export default __exports__